module.exports = __webpack_public_path__ + "static/media/canceled-activity-marker.dbef2cd6.png";